import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
export function createPageUrl(page) {
  // For client-expense-loop, we need to use the basename "/expense-loop"
  return `/expense-loop/${page}`;
}
